require("!!/srv/scratch/old-home/dyall/trinity/trinity-frontend-master/node_modules/script-loader/addScript.js")(require("!!/srv/scratch/old-home/dyall/trinity/trinity-frontend-master/node_modules/raw-loader/index.js!/srv/scratch/old-home/dyall/trinity/trinity-frontend-master/node_modules/chart.js/dist/Chart.js"))


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/script-loader!/srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/chart.js/dist/Chart.js
// module id = ../../../../script-loader/index.js!../../../../chart.js/dist/Chart.js
// module chunks = 2